/** @format */

export const FETCH_ACTIVITIES_REQUEST = "FETCH_ACTIVITIES_REQUEST";
export const FETCH_ACTIVITIES_SUCCESS = "FETCH_ACTIVITIES_SUCCESS";
export const FETCH_ACTIVITIES_FAILURE = "FETCH_ACTIVITIES_FAILURE";
export const EXPAND_ALL_ACTIVITIES = "EXPAND_ALL_ACTIVITIES";
export const COLLAPSE_ALL_ACTIVITIES = "COLLAPSE_ALL_ACTIVITIES";
